import React from 'react';
import classNames from 'classnames';

import { urls } from 'constants/urls';

import AnchorLink from 'components/AnchorLink';

import SpecialistShopLink from '../SpecialistShopsLinks/SpecialistShopLink';
import styles from '../SpecialistShopsLinks/SpecialistShopsLinks.scss';

const CustomerServiceLinks = () => (
  <div
    className={classNames(styles.wrapper, styles.minusRight)}
    data-testid="customer-service-links"
  >
    <SpecialistShopLink
      link={{
        name: 'My Waitrose',
        tracking: 'topnav_control_myWaitrose',
        url: 'https://www.waitrose.com/ecom/my-waitrose',
      }}
    />
    <AnchorLink
      className={styles.link}
      key="customerService-find-store-link"
      to={urls.branchFinder}
      data-testid="find-store"
    >
      Find a store
    </AnchorLink>
    <AnchorLink
      className={styles.link}
      key="customerService-customer-service-link"
      to={urls.customerServiceHomePage}
      data-testid="customer-service"
    >
      Customer service
    </AnchorLink>
  </div>
);

CustomerServiceLinks.displayName = 'CustomerServiceLinks';

export default CustomerServiceLinks;
